// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instruction-close-icon:hover {
  color: rgb(92, 92, 92);
}

.instruction-text-content::-webkit-scrollbar {
  width: 8px; /* Set the width of the scrollbar */
}`, "",{"version":3,"sources":["webpack://./src/components/InstructionModal/InstructionModal.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU,EAAE,mCAAmC;AACjD","sourcesContent":[".instruction-close-icon:hover {\n  color: rgb(92, 92, 92);\n}\n\n.instruction-text-content::-webkit-scrollbar {\n  width: 8px; /* Set the width of the scrollbar */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
